import { Button, DialogActions } from "@mui/material";
import type { FC } from "react";

export const SendTestDialogButtons: FC<{
  setSaving: (value: boolean) => void;
  setTestDialog: (value: boolean) => void;
  publishing: boolean;
  isSubmitting: boolean;
  sendDisabled?: boolean;
}> = ({ setSaving, setTestDialog, publishing, isSubmitting, sendDisabled }) => {
  return (
    <DialogActions>
      <Button
        data-analytics-id="moment-form-send-test-dialog-cancel"
        onClick={() => {
          setTestDialog(false);
          setSaving(false);
        }}
        disabled={publishing}
      >
        Cancel
      </Button>
      <Button
        data-analytics-id="moment-form-send-test-dialog-send"
        type="submit"
        loading={isSubmitting}
        disabled={sendDisabled}
        variant="contained"
      >
        Send Test
      </Button>
    </DialogActions>
  );
};
